// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      analysisCauseOptions: [
        "Human",
        "Factory",
        "Install",
        "Comm",
        "Design",
        "Time",
        "Other"
      ],
      // eslint-disable-next-line
      analysisPatternOptions: [
        "Bathtub",
        "Wear",
        "Age",
        "Initial",
        "Random"
      ],
      // eslint-disable-next-line
      analysisEffectOptions: [
        "HF", // hazardous operation (light is sparking but working)
        "LF", // loss of function
        "CF", // catstrophic failure light operation resuled in fire
        "DO", // degraded operation light inesnity is lower
        "IN" // incepient fault light ensloure failed
      ],
      // eslint-disable-next-line
      analysisDetectOptions: [
        "IV", // investion visual
        "ID", // inspection detail
        "SA", // system alarm
        "ST", // system trip
        "TI", // test inspect
        "TS", // test specail
        "TF", // test function
        "UD" // undetected
      ],
      // eslint-disable-next-line
      analysisTypeOptions: [
        "FM" // failure mode
      ]
    };
  }
};
